<template>
  <li class="projectList__item">
    <a v-on:click="onClickShowDetails">
      <div class="projectInfo">
        <div class="projectInfo__img">
          <img :src="project.thmbURL" :alt="project.title">
        </div>
        <div class="projectInfo__data">
          <h1 class="projectList__item__title" v-html="project.title"></h1>
          <span class="projectList__item__client">{{ project.client }}</span>
        </div>
      </div>
    </a>
  </li>
</template>

<script>
export default {
  name: 'ProjectListItem',
  props: ['project'],
  data () {
    return {
      projectItemData: []
    }
  },
  methods: {
    onClickShowDetails: function (event) {
      this.$emit('showDetails', this.project.id)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
$itemPadding: 10px;
// Layout
.projectInfo {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  .projectInfo__img {
    width: 100%;
    display: none;
    @media (min-width: 1200px) {
      display:block;
    }
    img {
      width: 100%;
    }
  }
  .projectInfo__data {
    width: 100%;
    padding-left: $itemPadding;
  }
}
// Styles
.projectList__item {
  border-bottom: 1px dotted #c2c2c2;
  background-color: #ebebeb;
  &:hover {
    background-color: #f5f5f5;
  }
  &.active {
    background-color: #f3f3f3;
    -webkit-filter: grayscale(1);
    filter: grayscale(1);
    opacity: 0.5;
  }
  &:first-child {
    border-top: 1px dotted #c2c2c2;
  }
  a {
    display: block;
    padding: $itemPadding;
    cursor: pointer;
  }
  .projectList__item__title {
    font-size: 1.2rem;
    margin: 0;
    line-height: 1em;
    margin-bottom: 0;

  }
  .projectList__item__client {
    display: inline-block;
    font-size: 0.9rem;
    line-height: 1em;
    font-style: italic;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ProjectListItem.vue